// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clients-container {
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: 2rem auto;
}

.clients-list-box {
  display: flex;
  margin-top: 34px;
}
.clients-list-box .form-item {
  width: 100%;
}
.clients-list-box .dropdown {
  width: 50%;
}

.add-client-container {
  margin-top: 14px;
  position: relative;
  padding: 2em;
  padding-top: 0;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
}
.add-client-container.add-margin {
  padding-bottom: 2.5em;
}
@media screen and (max-width: 1024px) {
  .add-client-container.add-margin {
    padding-bottom: 80px;
  }
}

.delete-icon {
  display: block;
  width: 40px;
  height: 40px;
  padding: 28px 24px 0px 24px;
}
.delete-icon .delete-ico {
  background-color: var(--sherpa-midnight-200);
  border-radius: 50%;
  padding: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-icon .delete-ico .ico-delete {
  font-size: 24px;
  color: var(--sherpa-midnight-800);
}
@media screen and (max-width: 1024px) {
  .delete-icon {
    position: absolute;
    right: 46px;
    bottom: 28px;
  }
  .delete-icon.delete-data-treatment {
    bottom: 60px;
  }
}

.clients-list-box-cero {
  display: flex;
  margin-top: 34px;
}

.form-item-cero {
  width: 100%;
}
.form-item-cero__documentType {
  width: 100px;
  min-width: 100px;
}
.form-item-cero__document {
  width: 14%;
}
.form-item-cero__names {
  width: 21.01%;
}
.form-item-cero__phone {
  width: 15.16%;
  min-width: 120px;
}
.form-item-cero__amount {
  width: 17.3%;
  min-width: 130px;
}

.clients-functions {
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}
.clients-functions .clients-functions-add {
  display: flex;
  align-items: center;
}

.clients-functions-cero {
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
}
.clients-functions-cero .clients-functions-send-cero {
  display: flex;
  min-width: 180px;
  align-items: center;
}

.data-treatment-and-send {
  margin-top: 26px;
  display: flex;
  justify-content: space-between;
}
.data-treatment-and-send .send-button {
  min-width: 180px;
  margin-top: 10px;
}

.space-right {
  margin-right: 16px;
}

.space-end {
  margin-right: -32px;
}

.icon {
  display: flex;
  position: relative;
  width: 20px;
  height: 20px;
  font-size: 20px;
  align-items: center;
  justify-content: center;
  font-family: "bdb-icons", Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
}

.icon--gray {
  color: rgb(133, 133, 133);
}

.icon--blue {
  color: #0040a8;
}

.phone-error {
  font-family: Roboto-Regular Helvetica, Arial, Verdana, Tahoma, sans-serif;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 0.5px;
  color: var(--error-800);
}

.bdb-header__title {
  width: 288px;
  height: 32px;
  font-family: Montserrat-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.4px;
  color: #333333;
}

@media screen and (max-width: 767px) {
  /* For mobile phones: */
  .bdb-header__title {
    width: 328px;
    height: 28px;
    font-family: Montserrat-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: -0.2px;
    color: #333333;
  }
  .clients-container {
    margin: 20px 16px 0px 16px;
  }
  .space-top {
    margin-top: 24px;
  }
  .clients-list-box {
    margin-top: 16px;
    flex-wrap: wrap;
  }
  .clients-list-box-cero {
    margin-top: 16px;
    flex-wrap: wrap;
  }
  .form-item {
    margin-top: 24px;
  }
  .form-item-cero {
    margin-top: 24px;
    width: 100% !important;
  }
  .dropdown {
    width: 50%;
  }
  .space-right {
    margin-right: 0px;
  }
  .space-end {
    margin-right: 0px;
  }
  .clients-functions {
    flex-direction: column;
    align-items: center;
  }
  .clients-functions-send {
    margin-top: 28px;
    margin-bottom: 29px;
  }
  .clients-functions-cero {
    flex-direction: column;
    align-items: center;
  }
  .clients-functions-send-cero {
    margin-top: 28px;
    margin-bottom: 29px;
  }
  .data-treatment-and-send {
    flex-direction: column;
    align-items: center;
  }
  .send-button {
    margin-top: 28px;
    margin-bottom: 29px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  /* For Tablets, Ipads (portrait): */
  .bdb-title-mobile {
    display: none;
  }
  .dbb-title-desktop {
    display: flex;
  }
  .bdb-header__title {
    width: 288px;
    height: 32px;
    font-family: Montserrat-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.4px;
    color: #333333;
  }
  .clients-container {
    margin: 32px 24px 0px 24px;
  }
  .clients-list-box {
    margin-top: 16px;
    margin-left: 0px;
    padding-left: 0px;
    flex-wrap: wrap;
  }
  .clients-list-box .form-item {
    width: 45%;
    margin-top: 24px;
    margin-right: 0px;
    padding-left: 26px;
  }
  .clients-list-box #dropdown-container {
    display: flex;
    width: 45%;
    align-items: flex-end;
    margin-right: 0px;
    padding-left: 26px;
  }
  .clients-list-box-cero {
    margin-top: 16px;
    flex-wrap: wrap;
  }
  .clients-list-box-cero .form-item-cero {
    width: 48.8% !important;
    margin-top: 24px;
  }
  .clients-list-box-cero .dropdown {
    width: 50%;
  }
  .space-right {
    margin-right: 0px;
  }
  .space-rigth-2 {
    margin-right: 16px;
  }
}
#ae_clients_addCliend {
  padding-left: 0;
  padding-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/components/list-clients/list-clients.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;AACJ;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AADF;AAGE;EACE,qBAAA;AADJ;AAEI;EAFF;IAGI,oBAAA;EACJ;AACF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAAF;AACE;EACE,4CAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAAI;EACE,eAAA;EACA,iCAAA;AAEN;AACE;EAnBF;IAoBI,kBAAA;IACA,WAAA;IACA,YAAA;EAEF;EADE;IACE,YAAA;EAGJ;AACF;;AACA;EACE,aAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;AAEF;AAAE;EACE,YAAA;EACA,gBAAA;AAEJ;AACE;EACE,UAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,aAAA;EACA,gBAAA;AADJ;AAIE;EACE,YAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAJF;AAME;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AALF;AAOE;EACE,gBAAA;EACA,gBAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yGAAA;AANF;;AASA;EACE,yBAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,yEAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;AANF;;AASA;EACE,YAAA;EACA,YAAA;EACA,+EAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AANF;;AASA;EACE,uBAAA;EAEA;IACE,YAAA;IACA,YAAA;IACA,+EAAA;IACA,eAAA;IACA,gBAAA;IACA,oBAAA;IACA,kBAAA;IACA,gBAAA;IACA,sBAAA;IACA,cAAA;EAPF;EAUA;IACE,0BAAA;EARF;EAWA;IACE,gBAAA;EATF;EAYA;IACE,gBAAA;IACA,eAAA;EAVF;EAaA;IACE,gBAAA;IACA,eAAA;EAXF;EAcA;IACE,gBAAA;EAZF;EAeA;IACE,gBAAA;IACA,sBAAA;EAbF;EAgBA;IACE,UAAA;EAdF;EAiBA;IACE,iBAAA;EAfF;EAkBA;IACE,iBAAA;EAhBF;EAmBA;IACE,sBAAA;IACA,mBAAA;EAjBF;EAoBA;IACE,gBAAA;IACA,mBAAA;EAlBF;EAqBA;IACE,sBAAA;IACA,mBAAA;EAnBF;EAsBA;IACE,gBAAA;IACA,mBAAA;EApBF;EAuBA;IACE,sBAAA;IACA,mBAAA;EArBF;EAwBA;IACE,gBAAA;IACA,mBAAA;EAtBF;AACF;AAyBA;EACE,mCAAA;EACA;IACE,aAAA;EAvBF;EAyBA;IACE,aAAA;EAvBF;EAyBA;IACE,YAAA;IACA,YAAA;IACA,+EAAA;IACA,eAAA;IACA,gBAAA;IACA,oBAAA;IACA,kBAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;EAvBF;EA0BA;IACE,0BAAA;EAxBF;EA2BA;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;EAzBF;EA2BE;IACE,UAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAzBJ;EA4BE;IACE,aAAA;IACA,UAAA;IACA,qBAAA;IACA,iBAAA;IACA,kBAAA;EA1BJ;EA8BA;IACE,gBAAA;IACA,eAAA;EA5BF;EA8BE;IACE,uBAAA;IACA,gBAAA;EA5BJ;EA+BE;IACE,UAAA;EA7BJ;EAiCA;IACE,iBAAA;EA/BF;EAkCA;IACE,kBAAA;EAhCF;AACF;AAmCA;EACE,eAAA;EACA,gBAAA;AAjCF","sourcesContent":[".clients-container {\n  display: flex;\n  flex-direction: column;\n  width: 95%;\n  margin: 2rem auto;\n}\n\n.clients-list-box {\n  display: flex;\n  margin-top: 34px;\n\n  .form-item {\n    width: 100%;\n  }\n\n  .dropdown {\n    width: 50%;\n  }\n}\n\n.add-client-container {\n  margin-top: 14px;\n  position: relative;\n  padding: 2em;\n  padding-top: 0;\n  background: #ffffff;\n  border: 1px solid #e5e5e5;\n  border-radius: 6px;\n\n  &.add-margin {\n    padding-bottom: 2.5em;\n    @media screen and (max-width: 1024px) {\n      padding-bottom: 80px;\n    }\n  }\n}\n\n.delete-icon {\n  display: block;\n  width: 40px;\n  height: 40px;\n  padding: 28px 24px 0px 24px;\n  .delete-ico {\n    background-color: var(--sherpa-midnight-200);\n    border-radius: 50%;\n    padding: 8px;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .ico-delete {\n      font-size: 24px;\n      color: var(--sherpa-midnight-800);\n    }\n  }\n  @media screen and (max-width: 1024px) {\n    position: absolute;\n    right: 46px;\n    bottom: 28px;\n    &.delete-data-treatment {\n      bottom: 60px;\n    }\n  }\n}\n\n.clients-list-box-cero {\n  display: flex;\n  margin-top: 34px;\n}\n\n.form-item-cero {\n  width: 100%;\n\n  &__documentType {\n    width: 100px;\n    min-width: 100px;\n  }\n\n  &__document {\n    width: 14%;\n  }\n\n  &__names {\n    width: 21.01%;\n  }\n\n  &__phone {\n    width: 15.16%;\n    min-width: 120px;\n  }\n\n  &__amount {\n    width: 17.3%;\n    min-width: 130px;\n  }\n}\n\n.clients-functions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 32px;\n\n  .clients-functions-add {\n    display: flex;\n    align-items: center;\n  }\n}\n\n.clients-functions-cero {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 32px;\n\n  .clients-functions-send-cero {\n    display: flex;\n    min-width: 180px;\n    align-items: center;\n  }\n}\n\n.data-treatment-and-send {\n  margin-top: 26px;\n  display: flex;\n  justify-content: space-between;\n\n  .send-button {\n    min-width: 180px;\n    margin-top: 10px;\n  }\n}\n\n.space-right {\n  margin-right: 16px;\n}\n\n.space-end {\n  margin-right: -32px;\n}\n\n.icon {\n  display: flex;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n  align-items: center;\n  justify-content: center;\n  font-family: 'bdb-icons', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n}\n\n.icon--gray {\n  color: rgb(133, 133, 133);\n}\n\n.icon--blue {\n  color: #0040a8;\n}\n\n.phone-error {\n  font-family: Roboto-Regular Helvetica, Arial, Verdana, Tahoma, sans-serif;\n  font-size: 12px;\n  line-height: 18px;\n  margin-bottom: 0.5px;\n  color: var(--error-800);\n}\n\n.bdb-header__title {\n  width: 288px;\n  height: 32px;\n  font-family: Montserrat-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.33;\n  letter-spacing: -0.4px;\n  color: #333333;\n}\n\n@media screen and (max-width: 767px) {\n  /* For mobile phones: */\n\n  .bdb-header__title {\n    width: 328px;\n    height: 28px;\n    font-family: Montserrat-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif;\n    font-size: 20px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.4;\n    letter-spacing: -0.2px;\n    color: #333333;\n  }\n\n  .clients-container {\n    margin: 20px 16px 0px 16px;\n  }\n\n  .space-top {\n    margin-top: 24px;\n  }\n\n  .clients-list-box {\n    margin-top: 16px;\n    flex-wrap: wrap;\n  }\n\n  .clients-list-box-cero {\n    margin-top: 16px;\n    flex-wrap: wrap;\n  }\n\n  .form-item {\n    margin-top: 24px;\n  }\n\n  .form-item-cero {\n    margin-top: 24px;\n    width: 100% !important;\n  }\n\n  .dropdown {\n    width: 50%;\n  }\n\n  .space-right {\n    margin-right: 0px;\n  }\n\n  .space-end {\n    margin-right: 0px;\n  }\n\n  .clients-functions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .clients-functions-send {\n    margin-top: 28px;\n    margin-bottom: 29px;\n  }\n\n  .clients-functions-cero {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .clients-functions-send-cero {\n    margin-top: 28px;\n    margin-bottom: 29px;\n  }\n\n  .data-treatment-and-send {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .send-button {\n    margin-top: 28px;\n    margin-bottom: 29px;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  /* For Tablets, Ipads (portrait): */\n  .bdb-title-mobile {\n    display: none;\n  }\n  .dbb-title-desktop {\n    display: flex;\n  }\n  .bdb-header__title {\n    width: 288px;\n    height: 32px;\n    font-family: Montserrat-SemiBold, Helvetica, Arial, Verdana, Tahoma, sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: -0.4px;\n    color: #333333;\n  }\n\n  .clients-container {\n    margin: 32px 24px 0px 24px;\n  }\n\n  .clients-list-box {\n    margin-top: 16px;\n    margin-left: 0px;\n    padding-left: 0px;\n    flex-wrap: wrap;\n\n    .form-item {\n      width: 45%;\n      margin-top: 24px;\n      margin-right: 0px;\n      padding-left: 26px;\n    }\n\n    #dropdown-container {\n      display: flex;\n      width: 45%;\n      align-items: flex-end;\n      margin-right: 0px;\n      padding-left: 26px;\n    }\n  }\n\n  .clients-list-box-cero {\n    margin-top: 16px;\n    flex-wrap: wrap;\n\n    .form-item-cero {\n      width: 48.8% !important;\n      margin-top: 24px;\n    }\n\n    .dropdown {\n      width: 50%;\n    }\n  }\n\n  .space-right {\n    margin-right: 0px;\n  }\n\n  .space-rigth-2 {\n    margin-right: 16px;\n  }\n}\n\n#ae_clients_addCliend {\n  padding-left: 0;\n  padding-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
